import superagent from 'superagent'

const users = {
  search: (props) => {
    const { searchStr, token, pageNumber = 0, pageSize = 20 } = props
    return new Promise((resolve, reject) => {
      superagent
        // .get(`${__API_URI__}/User/Search/?search=${searchStr}`)
        .get(`${__API_URI__}/user/search?search=${searchStr}&page=${pageNumber}&pageSize=${pageSize}`)
        .set('Authorization', `Bearer ${token}`)
        .set('Content-Type', 'application/json')
        .set('Platform', 'Web')
        .set('Version', `${__version__}`)
        .end((err, res) => {
          if (err) {
            return reject(err)
          }
          resolve(res.body)
        })
    })
  }
}

export default users